// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1TbLx","content":"GlobalSearch_content__32cKq"};